var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerSuccess = function SvgCustomerSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 5,
    d: "M13.299 29c5.964 0 10.799-4.834 10.799-10.799S19.263 7.402 13.299 7.402 2.5 12.237 2.5 18.202C2.5 24.164 7.335 29 13.299 29Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.957.36a1 1 0 0 1 1.64.768v3.775h3.775a1 1 0 0 1 .77 1.64l-3.26 3.91a1 1 0 0 1-.768.36h-3.806l-5.1 5.099a5.418 5.418 0 1 1-1.976-2.264l4.456-4.455V4.386a1 1 0 0 1 .36-.768L24.956.36Z"
  })));
};
export default SvgCustomerSuccess;